import { useSelector } from 'react-redux';
import { useActiveLocation } from '../../../hooks/useActiveLocation';
import type { RootState } from '../../../store';
import type { RestaurantInfo } from '../types';
import { Resource, useResource } from './useResource';

/** The restaurant whose menus are shown: Admin's pick in the top bar, everyone else's own. */
export const useRestaurantId = (): string | null => {
    const { restaurantId } = useActiveLocation();
    const own = useSelector((s: RootState) => s.auth.user?.restaurant?.id ?? null);
    return restaurantId ?? own;
};

export const useRestaurantInfo = (restaurantId: string | null): Resource<RestaurantInfo> =>
    useResource<RestaurantInfo>(restaurantId ? `/restaurants/${restaurantId}` : null);
